import { NativeModules, Platform } from 'react-native';
import { getTenantId } from '../../base/whitelabel/functions';
import { apiClient } from '../../shared/api-client';
import { getPersistentJson } from '../../vrs-auth/storage';
import { redactDiagnosticRecord, redactDiagnosticValue } from './diagnosticRedaction';
import { getMobileLogs, mobileLog } from './logging';
let installed = false;
function getMobileReleaseIdentity() {
    const appInfo = (NativeModules?.AppInfo || {});
    const appName = typeof appInfo.name === 'string' ? appInfo.name : undefined;
    const appVersion = typeof appInfo.version === 'string' ? appInfo.version : undefined;
    const buildNumber = typeof appInfo.buildNumber === 'string' || typeof appInfo.buildNumber === 'number'
        ? String(appInfo.buildNumber)
        : undefined;
    return {
        appName,
        appVersion,
        buildNumber,
        tenantId: getTenantId()
    };
}
function getErrorUtils() {
    const candidate = globalThis.ErrorUtils;
    return candidate?.setGlobalHandler ? candidate : null;
}
function normalizeError(error) {
    if (error instanceof Error) {
        return {
            message: error.message,
            stack: error.stack
        };
    }
    if (error && typeof error === 'object') {
        const shaped = error;
        return {
            message: typeof shaped.message === 'string' ? shaped.message : JSON.stringify(redactDiagnosticValue(error)),
            stack: typeof shaped.stack === 'string' ? shaped.stack : undefined
        };
    }
    return {
        message: String(error || 'Unknown mobile error')
    };
}
export async function reportMobileError(error, context = {}) {
    const normalized = normalizeError(error);
    const release = getMobileReleaseIdentity();
    const activeCall = getPersistentJson('vrs_active_call');
    const correlatedContext = {
        ...context,
        appName: release.appName,
        buildNumber: release.buildNumber,
        callId: activeCall?.callId,
        hasRoomName: Boolean(activeCall?.roomName),
        requestId: activeCall?.requestId
    };
    mobileLog('error', String(context.event || 'mobile_runtime_error'), {
        callId: activeCall?.callId,
        fatal: context.fatal,
        message: normalized.message,
        requestId: activeCall?.requestId
    }, { console: false });
    await apiClient.post('/api/error-reports', redactDiagnosticRecord({
        // This module is shared with the web bundle through the react-native
        // shim; a web caller reporting as 'mobile' sends operators chasing
        // the wrong platform in the Client Error Reports panel.
        source: typeof navigator !== 'undefined' && navigator.product === 'ReactNative' ? 'mobile' : 'web',
        level: 'error',
        event: String(context.event || 'mobile_runtime_error'),
        message: normalized.message,
        stack: normalized.stack,
        appVersion: release.appVersion && release.buildNumber
            ? `${release.appVersion} (${release.buildNumber})`
            : release.appVersion,
        platform: `${Platform.OS} ${Platform.Version}`,
        tenantId: release.tenantId,
        payload: correlatedContext,
        logs: getMobileLogs({ limit: 40 })
    }));
}
export function installMobileErrorReporting() {
    if (installed) {
        return;
    }
    installed = true;
    const errorUtils = getErrorUtils();
    const previousHandler = errorUtils?.getGlobalHandler?.();
    errorUtils?.setGlobalHandler?.((error, isFatal) => {
        reportMobileError(error, {
            event: 'mobile_global_error',
            fatal: Boolean(isFatal)
        }).catch(() => {
            // Reporting must never mask the original crash.
        });
        previousHandler?.(error, isFatal);
    });
}
